import './App.css';
import NavBar from './components/NavBar';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Blogs from './components/Blogs';
import Projects from './components/Projects';
import Skills from './components/subcomponents/Skills';

function App() {
  return (
    <Router>
      <div className="App" id="app">
        <NavBar/>
        <div className="con">
          <Routes>
            <Route exact path="/" element={<Home/>}/>
            <Route path="/about" element={<About/>}/>
            <Route path="/blogs" element={<Blogs/>}/>
            <Route path="/projects" element={<Projects/>}/>
            <Route path="/skills" element={<Skills/>}/>
          </Routes>
        </div>
      </div>
    </Router>
    
  );
}

export default App;
